// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"651365a806fcf1267abf","303":"7cfdaf5728168769382c","495":"844f4c9ec203d50a79b7"}[chunkId] + ".js";
};